<template>
  <div>
    <div class="d-flex flex-wrap align-items-center">
      <div class="kit__utils__avatar kit__utils__avatar--size64 flex-shrink-0 mr-5 mb-3">
        <img src="resources/images/avatars/1.png" alt="Mary Stanform" />
      </div>
      <div class="mr-auto mb-3">
        <div class="text-dark font-weight-bold font-size-24">
          <span class="mr-3">Milić Popović</span>
          <span
            class="align-middle text-primary text-uppercase font-size-12 badge badge-light"
          >u procesu zaposlenja</span>
        </div>
        <div>Kadrovska / Manager</div>
      </div>
      <a
        class="btn btn-light btn-lg text-blue font-size-14"
        href="javascript: void(0);"
      >Kontakt →</a>
    </div>
    <a-tabs defaultActiveKey="1" class="kit-tabs-bordered mb-2" @change="employeeTabChange">
      <a-tab-pane tab="Lični podaci" key="1" />
      <a-tab-pane tab="Radni podaci" key="2" />
      <a-tab-pane tab="Odmori i odsustva" key="3" />
      <a-tab-pane tab="Reversi i zaduženja" key="4" />
    </a-tabs>
    <div class="row mb-5" v-if="tab === '1'">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0 mr-2 font-size-18 text-uppercase">
              <strong>Opšti podaci</strong>
            </h5>
          </div>
          <div class="card-body">

        <h5 class="mb-4">
        </h5>
        <a-form :form="form" layout="vertical">
          <div class="row">
            <div class="col-md-4">
              <a-form-item label="Ime">
                <a-input placeholder="" />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Prezime">
                <a-input placeholder="" />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Pol">
                <a-select
                  v-decorator="[
                  'residence',
                  {
                    initialValue: [''],
                    rules: [{ type: 'array', message: 'Izaaberite pol zaposlenog!' }],
                  }
                  ]"
                  :options="genders"
                />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Ime jednog roditelja">
                <a-input placeholder="" />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="JMBG*">
                <a-input placeholder="" />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Datum Rođenja">
                <a-input />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Broj LK">
                <a-input placeholder="Lična karta" />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Broj radne knjižice">
                <a-input placeholder="" />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Reg.br radne knjižice">
                <a-input placeholder="" />
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <a-checkbox
                  @change="residentCahanged"
                >Zaposleni je strani državljanin</a-checkbox>
              </a-form-item>
              <a-form-item v-show="nonResident" label="Broj radne dozvole">
                <a-input placeholder="Reg. br dozvole" />
              </a-form-item>
            </div>
            <div class="col-md-12">
              <h6 class="text-uppercase">Prebivalište</h6>
            </div>
            <div class="col-md-4">
              <a-form-item label="Adresa">
                <a-input placeholder="U formi Pošta, ulica i broj" />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Država">
                <a-input placeholder="" />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Grad">
                <a-input />
              </a-form-item>
            </div>
            <div class="col-md-12">
              <h6 class="text-uppercase">Rođenje</h6>
            </div>
            <div class="col-md-4">
              <a-form-item label="Adresa">
                <a-input placeholder="U formi Pošta, ulica i broj" />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Država">
                <a-input placeholder="" />
              </a-form-item>
            </div>
            <div class="col-md-4">
              <a-form-item label="Grad">
                <a-input />
              </a-form-item>
            </div>
            <div class="col-md-12">
              <h6 class="text-uppercase">Privatni kontakt podaci</h6>
            </div>
            <div class="col-md-6">
              <a-form-item label="Email">
                <a-input placeholder="Email" />
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Telefon">
                <a-input placeholder="+382" />
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <a-checkbox
                  default-checked
                >Zaposleni potvrdio da lični podaci mogu da se obrade u svrhu formiranja ugovora.</a-checkbox>
              </a-form-item>
              <a-form-item>
                <button type="button" class="btn btn-primary px-5">Sačuvaj podatke</button>
              </a-form-item>
            </div>
          </div>
        </a-form>

          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0 mr-2 font-size-18 text-uppercase">
              <strong>Dokumentacija</strong>
            </h5>
          </div>
          <div class="card-body">
            <div class="row">
            <div class="col-12">
              <a-form-item>
                <a-upload-dragger>
                  <p class="ant-upload-drag-icon">
                    <a-icon type="inbox" />
                  </p>
                  <p class="ant-upload-text">Slika zaposlenog</p>
                  <p
                    class="ant-upload-hint"
                  >U JPG ili PNG formatu, max dimenzija 512px x 512px</p>
                </a-upload-dragger>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <a-upload-dragger>
                  <p class="ant-upload-drag-icon">
                    <a-icon type="inbox" />
                  </p>
                  <p class="ant-upload-text">CV, motivaciono pismo ili prijava za rad</p>
                  <p
                    class="ant-upload-hint"
                  >Kliknite ili prevucite fajl za dodavanje</p>
                </a-upload-dragger>
              </a-form-item>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5" v-if="tab === '2'">
      <div class="col-md-4">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0 mr-2 font-size-18 text-uppercase">
              <strong>Opšti radni podaci</strong>
            </h5>
          </div>
          <div class="card-body">

        <h5 class="mb-4">
        </h5>
        <a-form :form="form" layout="vertical">
          <div class="row">
            <div class="col-md-12">
              <a-form-item label="Nedjeljno angažovanje">
                <a-input placeholder="Broj radnih sati: 40" />
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Neto zarada EUR">
                <a-input placeholder="" />
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Koeficijent">
                <a-input placeholder="5.22" />
              </a-form-item>
            </div>
            <div class="col-md-12">
              <h6 class="text-uppercase">Lokacija rada</h6>
            </div>
            <div class="col-12">
              <a-form-item>
                <a-checkbox
                  @change="homeOfficeChanged"
                >Rad od kuće</a-checkbox>
              </a-form-item>
            </div>

            <div class="col-md-12">
              <a-form-item label="Adresa">
                <a-input :disabled="homeOffice" placeholder="U formi Pošta, ulica i broj" />
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Država">
                <a-input :disabled="homeOffice" placeholder="" />
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Grad">
                <a-input :disabled="homeOffice" />
              </a-form-item>
            </div>

            <div class="col-md-12">
              <h6 class="text-uppercase">Hijerarhija</h6>
            </div>

            <div class="col-md-12">
              <a-form-item label="Nadređeni">
                <a-select
                  v-decorator="[
                  'hierarchy',
                  {
                    initialValue: ['P'],
                    rules: [{ type: 'array', message: 'Izaaberite nadređenog!' }],
                  }
                  ]"
                  :options="hierarchy"
                />
              </a-form-item>

            </div>

            <div class="col-12">
              <a-form-item>
                <button type="button" class="btn btn-primary px-5">Sačuvaj podatke</button>
              </a-form-item>
            </div>
          </div>
        </a-form>

          </div>
        </div>
      </div>

      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-flex align-items-center">
            <h5 class="mb-0 mr-2 font-size-18 text-uppercase d-flex flex-column justify-content-center mr-auto">
              <strong>Ugovori i Aneksi</strong>
            </h5>
            <div class="d-flex flex-column">
              <a class="btn btn-primary">Dodajte novi ugovor</a>
            </div>
          </div>
          <div class="card-body">
            <!-- Table ugovori here -->
            <a-table :columns="columns" :dataSource="data">
              <div
                slot="filterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                class="custom-filter-dropdown"
              >
                <a-input
                  v-ant-ref="c => searchInput = c"
                  :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm)"
                  style="width: 188px; margin-bottom: 8px; display: block;"
                />
                <a-button
                  type="primary"
                  @click="() => handleSearch(selectedKeys, confirm)"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                >Search</a-button>
                <a-button
                  @click="() => handleReset(clearFilters)"
                  size="small"
                  style="width: 90px"
                >Reset</a-button>
              </div>
              <a-icon
                slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"
              />

              <template slot="name" slot-scope="text, record">
                  <h6>{{record.name}}</h6>
                  <span>{{record.email}}</span>
              </template>
              <template slot="progress" slot-scope="bar">
                <div class="progress">
                  <div
                    :class="['progress-bar', bar.color]"
                    :style="{width: bar.value + '%'}"
                    role="progressbar"
                  ></div>
                </div>
              </template>
              <template slot="role" slot-scope="text, record">
                <span class="font-weight-bold">{{text}}</span><br>
                <span class="font-weight-light">{{record.department}}</span>
              </template>
              <a
                slot="id"
                slot-scope="text"
                href="javascript: void(0);"
                class="btn btn-sm btn-light"
              >{{text}}</a>
              <span slot="period" slot-scope="text, record">{{calculatePeriod(record)}}</span>
              <template slot="expires" slot-scope="text, record">
                <span v-if="record.expiresin === 0" class="font-size-12 badge badge-danger">istekao</span>
                <span v-if="record.expiresin > 0 && record.expiresin < 15" class="font-size-12 badge badge-warning">{{ record.expiresin }} dana</span>
                <span v-if="record.expiresin > 15" class="font-size-12 badge badge-default">15+ dana</span>
              </template>
              <span slot="reportingto" slot-scope="text">{{text}}</span>
              <span
                slot="type"
                slot-scope="text"
                :class="getClassForContractType(text)"
              >{{text}}</span>
              <span slot="action">
                <a href="javascript: void(0);" class="btn btn-sm btn-light mr-2">
                  <i class="fe fe-edit mr-2" />
                  Pregled
                </a>
              </span>
            </a-table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5" v-if="tab === '3'">
      <div class="col-md-4">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0 mr-2 font-size-18 text-uppercase">
              <strong>Presjek stanja</strong>
            </h5>
          </div>
        </div>

        <div class="card bg-light border-danger">
          <div class="card-body pt-3 pb-3">
            <div class="text-uppercase text-danger font-weight-bold">Prenos odmora</div>
            <div class="text-left text-blue">
              <div class="font-weight-bold font-size-24">Godišnji odmor // 2019</div>
              <div>preostalo 4 dana</div>
            </div>
          </div>
        </div>

        <div class="card bg-light border-blue">
          <div class="card-body pt-3 pb-3">
            <div class="text-uppercase text-dark font-weight-bold">Tekuća godina</div>
            <div class="text-left text-blue">
              <div class="font-weight-bold font-size-24">Godišnji odmor // 2020</div>
              <div>24 dana <span class="text-muted">(odmor u cjelosti)</span></div>
            </div>
          </div>
        </div>

      </div>

      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-flex align-items-center">
            <h5 class="mb-0 mr-2 font-size-18 text-uppercase d-flex flex-column justify-content-center mr-auto">
              <strong>Odmori i odsustva</strong>
            </h5>
            <div class="d-flex flex-column">
              <a class="btn btn-primary">Zahtjev za odmor/odsustvo</a>
            </div>
          </div>
          <div class="card-body">
            <!-- Table ugovori here -->
            <a-table :columns="columns2" :dataSource="data2">
              <div
                slot="filterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                class="custom-filter-dropdown"
              >
                <a-input
                  v-ant-ref="c => searchInput = c"
                  :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm)"
                  style="width: 188px; margin-bottom: 8px; display: block;"
                />
                <a-button
                  type="primary"
                  @click="() => handleSearch(selectedKeys, confirm)"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                >Search</a-button>
                <a-button
                  @click="() => handleReset(clearFilters)"
                  size="small"
                  style="width: 90px"
                >Reset</a-button>
              </div>
              <a-icon
                slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"
              />

              <template slot="name" slot-scope="text, record">
                  <h6>{{record.name}}</h6>
                  <span>{{record.email}}</span>
              </template>
              <template slot="progress" slot-scope="bar">
                <div class="progress">
                  <div
                    :class="['progress-bar', bar.color]"
                    :style="{width: bar.value + '%'}"
                    role="progressbar"
                  ></div>
                </div>
              </template>
              <template slot="role" slot-scope="text, record">
                <span class="font-weight-bold">{{text}}</span><br>
                <span class="font-weight-light">{{record.department}}</span>
              </template>
              <a
                slot="id"
                slot-scope="text"
                href="javascript: void(0);"
                class="btn btn-sm btn-light"
              >{{text}}</a>
              <span slot="period" slot-scope="text, record">{{calculatePeriod(record)}}</span>
              <template slot="expires" slot-scope="text, record">
                <span v-if="record.expiresin === 0" class="font-size-12 badge badge-danger">istekao</span>
                <span v-if="record.expiresin > 0 && record.expiresin < 15" class="font-size-12 badge badge-warning">{{ record.expiresin }} dana</span>
                <span v-if="record.expiresin > 15" class="font-size-12 badge badge-default">15+ dana</span>
              </template>
              <span slot="reportingto" slot-scope="text">{{text}}</span>
              <span
                slot="type"
                slot-scope="text"
                :class="getClassForContractType(text)"
              >{{text}}</span>
              <span slot="action">
                <a href="javascript: void(0);" class="btn btn-sm btn-light mr-2">
                  <i class="fe fe-edit mr-2" />
                  Pregled
                </a>
              </span>
            </a-table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5" v-if="tab === '4'">
      <div class="col-md-4">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0 mr-2 font-size-18 text-uppercase">
              <strong>Avansi</strong>
            </h5>
          </div>
        </div>

        <div class="card bg-light border-danger">
          <div class="card-body pt-3 pb-3">
            <div class="text-uppercase text-danger font-weight-bold">Trenutno zaduženje</div>
            <div class="text-left text-blue">
              <div class="font-weight-bold font-size-24">EUR 120.00</div>
              <div class="text-muted">isplaćen 02.02.2020</div>
              <div class="text-right"><a class="btn">Povraćaj sredstava <i class="fe fe-arrow-right" /></a></div>
            </div>
          </div>
        </div>

      </div>

      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-flex align-items-center">
            <h5 class="mb-0 mr-2 font-size-18 text-uppercase d-flex flex-column justify-content-center mr-auto">
              <strong>Reversi i zaduženja</strong>
            </h5>
            <div class="d-flex flex-column">
              <a class="btn btn-primary">Novo zaduženje</a>
            </div>
          </div>
          <div class="card-body">
            <!-- Table ugovori here -->
            <a-table :columns="columns3" :dataSource="data3">
              <div
                slot="filterDropdown"
                slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                class="custom-filter-dropdown"
              >
                <a-input
                  v-ant-ref="c => searchInput = c"
                  :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]"
                  @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                  @pressEnter="() => handleSearch(selectedKeys, confirm)"
                  style="width: 188px; margin-bottom: 8px; display: block;"
                />
                <a-button
                  type="primary"
                  @click="() => handleSearch(selectedKeys, confirm)"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                >Search</a-button>
                <a-button
                  @click="() => handleReset(clearFilters)"
                  size="small"
                  style="width: 90px"
                >Reset</a-button>
              </div>
              <a-icon
                slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"
              />

              <template slot="name" slot-scope="text, record">
                  <h6>{{record.name}}</h6>
                  <span>{{record.email}}</span>
              </template>
              <template slot="progress" slot-scope="bar">
                <div class="progress">
                  <div
                    :class="['progress-bar', bar.color]"
                    :style="{width: bar.value + '%'}"
                    role="progressbar"
                  ></div>
                </div>
              </template>
              <template slot="role" slot-scope="text, record">
                <span class="font-weight-bold">{{text}}</span><br>
                <span class="font-weight-light">{{record.department}}</span>
              </template>
              <a
                slot="id"
                slot-scope="text"
                href="javascript: void(0);"
                class="btn btn-sm btn-light"
              >{{text}}</a>
              <span slot="period" slot-scope="text, record">{{calculatePeriod(record)}}</span>
              <template slot="expires" slot-scope="text, record">
                <span v-if="record.expiresin === 0" class="font-size-12 badge badge-danger">istekao</span>
                <span v-if="record.expiresin > 0 && record.expiresin < 15" class="font-size-12 badge badge-warning">{{ record.expiresin }} dana</span>
                <span v-if="record.expiresin > 15" class="font-size-12 badge badge-default">15+ dana</span>
              </template>
              <span slot="reportingto" slot-scope="text">{{text}}</span>
              <span
                slot="type"
                slot-scope="text"
                :class="getClassForContractType(text)"
              >{{text}}</span>
              <span slot="action">
                <a href="javascript: void(0);" class="btn btn-sm btn-light mr-2">
                  <i class="fe fe-edit mr-2" />
                  Pregled
                </a>
              </span>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import data from './data.json'
import data2 from './data2.json'
import data3 from './data3.json'

const columns = [
  {
    title: 'Tip',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' },
  },
  {
    title: 'Od / Do',
    scopedSlots: { customRender: 'period' },
  },
  {
    title: 'Ističe za',
    scopedSlots: { customRender: 'expires' },
  },
  {
    title: 'Naslov',
    dataIndex: 'title',
  },
  {
    title: 'Opcije',
    scopedSlots: { customRender: 'action' },
  },
]

const columns2 = [
  {
    title: 'Tip',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' },
  },
  {
    title: 'Od / Do',
    scopedSlots: { customRender: 'period' },
  },
  {
    title: 'Trajanje',
    scopedSlots: { customRender: 'expires' },
  },
  {
    title: 'Osnov',
    dataIndex: 'title',
  },
  {
    title: 'Opcije',
    scopedSlots: { customRender: 'action' },
  },
]

const columns3 = [
  {
    title: 'Tip opreme',
    dataIndex: 'type',
    scopedSlots: { customRender: 'type' },
  },
  {
    title: 'Datum zaduženja',
    dataIndex: 'date',
  },
  {
    title: 'Osnov',
    dataIndex: 'title',
  },
  {
    title: 'Opcije',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  data: function () {
    return {
      searchText: '',
      searchInput: null,
      data,
      columns,
      data2,
      columns2,
      data3,
      columns3,

      tab: '1',
      nonResident: false,
      homeOffice: false,
      genders: [
        {
          value: 'M',
          title: 'Muški',
        },
        {
          value: 'Z',
          title: 'Ženski',
        },
      ],
      hierarchy: [
        {
          value: 'P',
          title: 'Petar Petrović - HR Direktor',
        },
        {
          value: 'M',
          title: 'Marko Marković - Izvršni',
        },
      ],
    }
  },
  methods: {
    getClassForContractType (type) {
      var baseClass = 'font-size-12 badge badge-'
      switch (type) {
        case 'permanent':
          baseClass += 'success'
          break
        case 'limited':
          baseClass += 'warning'
          break
        case 'annex':
          baseClass += 'default'
          break
        case 'trial':
          baseClass += 'primary'
          break

        default:
          break
      }

      return baseClass
    },
    calculatePeriod (record) {
      if (record.type === 'permanent') {
        return record.from
      } else {
        return record.from + ' - ' + record.to
      }
    },
    residentCahanged (e) {
      this.nonResident = e.target.checked
    },
    homeOfficeChanged (e) {
      this.homeOffice = e.target.checked
    },
    employeeTabChange: function (tabIndex) {
      this.tab = tabIndex
    },
  },
}
</script>
